import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { createUser, loginUser } from "../../../redux/authSlice/authSlice";
import notify from "../../../hooks/useNotifaction";

export default function RegistrationInputs({ Signin }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { status, error } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  function handleInputs(e) {
    setUser({ ...user, [e.target.id]: e.target.value });
  }
  const [user, setUser] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user.email || !user.password) {
      notify("ادخل البريد الالكتروني وكلمة المرور", "error");
      return;
    }
    try {
      let res;
      if (!Signin) {
        res = await dispatch(
          loginUser({
            email: user.email,
            password: user.password,
          })
        ).unwrap();
        notify(res?.message || "تم تسجيل الدخول بنجاح", "success");
        navigate("/");
      } else {
        res = await dispatch(
          createUser({
            name: user.name,
            email: user.email,
            phone: user.phone,
            password: user.password,
          })
        ).unwrap();
        notify(res?.message || "تم إنشاء الحساب بنجاح", "success");
        navigate("/Signin");
      }
      setUser({
        name: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
      });
    } catch (error) {
      notify(error?.message || "حدث خطأ حاول مرة أخري", "error");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        {Signin && (
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              الاسم
            </label>
            <input type="text" className="form-control" value={user.name} id="name" placeholder="ادخل اسمك" onChange={handleInputs} />
          </div>
        )}
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            الايميل
          </label>
          <input type="email" className="form-control" id="email" value={user.email} placeholder="example@gmal.com" onChange={handleInputs} />
        </div>
        {Signin && (
          <div className="mb-3">
            <label htmlFor="phone" className="form-label">
              رقم الهاتف
            </label>
            <input type="phone" className="form-control" id="phone" value={user.phone} placeholder="ادخل رقم الهاتف" onChange={handleInputs} />
          </div>
        )}
        <div className="mb-3">
          <label htmlFor="password" className="form-label">
            الرقم السري
          </label>
          <input type="password" className="form-control" id="password" value={user.password} placeholder="ادخل الرقم السري" onChange={handleInputs} />
        </div>
        {Signin && (
          <div className="mb-3">
            <label htmlFor="confirmPassword" className="form-label">
              تأكيد الرقم السري
            </label>
            <input type="password" className="form-control" id="confirmPassword" placeholder="ادخل الرقم السري مرة اخري" onChange={handleInputs} />
          </div>
        )}
        <div className="mb-3">
          <button type="submit" className="btn btn-primary w-100">
            تسجيل
          </button>
          <Link to={Signin ? "/Signin" : "/Registration"} className="ms-2">
            {" "}
            حساب جديد{" "}
          </Link>
        </div>
      </form>
    </>
  );
}
